import React, { createContext, FC, useCallback, useContext, useEffect, useState } from "react";
import { LanguageKeys } from "./LanguageKeys";
import { Translator } from "./translator";
import { setGlobalTranslator } from '../services/utilities/ServiceError';

const getDefaultLanguageCode = () => {
    const storedLanguage = window.sessionStorage.getItem("selectedLanguage");
    const localCode = storedLanguage || window.navigator.language;
    return localCode.split("-")[0] || LanguageKeys.english;
}

interface Locale {
    locale: string, 
    setLocale: (locale: string) => void,
    translate: Translator
} 

export const LocaleContext = createContext<Locale>({ locale: '', setLocale: () => { }, translate: new Translator(LanguageKeys.english) });

export const useLocale = () : Locale => {
    return useContext(LocaleContext);
}

const TranslationsContextProvider: FC = ({ children }) => {
    const [locale, setLocale] = useState(getDefaultLanguageCode());
    const translator = new Translator(locale);

    const forceUpdate = useCallback((locale: string) => {
        window.sessionStorage.setItem("selectedLanguage", locale);
    }, [locale]);

    useEffect(() => {
        forceUpdate(locale);
        setGlobalTranslator(translator);
    }, [locale]);

    return <LocaleContext.Provider value={{ locale, setLocale, translate: translator }}>
        {children}
    </LocaleContext.Provider>
}

export default TranslationsContextProvider;
